import {
	ARGENTINIAN_PESO_CODE,
	BRASIL_REAL_CODE,
	PERUVIAN_SOL_CODE,
	USA_DOLLAR_CODE,
	PERUVIAN_SOL_CURRENCY_SIGN,
	BRASIL_REAL_CURRENCY_SIGN,
	GENERAL_CURRENCY_SIGN,
	CULTURES_WITH_DECIMAL_DOT,
} from "./constants";
export const CURRENCIES_WITH_DECIMALS = [ARGENTINIAN_PESO_CODE, BRASIL_REAL_CODE, PERUVIAN_SOL_CODE, USA_DOLLAR_CODE];

export interface NumberFormatterParams {
	amount: number;
	culture: string;
	currency?: string;
	forcedToRemoveDecimals?: boolean;
	isMiles?: boolean;
	leadingSign?: boolean;
	omitGrouping?: boolean;
	omitSpace?: boolean;
}

export const useNumberFormatter = () => {
	const formatNumber = (data: NumberFormatterParams) => {
		if (!data.currency && !data.isMiles) return data.amount.toString();

		const result = { ...data };
		result.leadingSign = data.isMiles ? false : data.leadingSign === undefined ? true : data.leadingSign;
		const currencySymbol = getCurrencySign(data.currency);

		const useDecimals =
			!data.forcedToRemoveDecimals &&
			!data.isMiles &&
			CURRENCIES_WITH_DECIMALS.indexOf(data.currency.toUpperCase()) > -1;

		const useDecimalDot = CULTURES_WITH_DECIMAL_DOT.indexOf(data.culture.toLowerCase()) > -1;

		result.amount = useDecimals ? Math.round(data.amount * 100) / 100 : Math.round(data.amount);
		let str = useDecimals ? result.amount.toFixed(2) : result.amount.toString();
		str = useDecimalDot ? str : str.replace(".", ",");

		str = data.omitGrouping
			? str
			: useDecimalDot
			? str.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			: str.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

		return result.leadingSign
			? data.omitSpace || data.isMiles
				? `${currencySymbol}${str}`
				: `${currencySymbol} ${str}`
			: str;
	};

	const getCurrencySign = (currencyCode?: string): string => {
		if (currencyCode?.toUpperCase() === PERUVIAN_SOL_CODE) return PERUVIAN_SOL_CURRENCY_SIGN;

		return currencyCode?.toUpperCase() === BRASIL_REAL_CODE ? BRASIL_REAL_CURRENCY_SIGN : GENERAL_CURRENCY_SIGN;
	};

	return { formatNumber, getCurrencySign };
};
